package com.vizio.redwolf.m2m.model

import kotlinx.serialization.Serializable

@Serializable
data class M2MTokenRequestInfo(
    val serviceId: String,
    val serviceSecret: String
)